import { useMetaData } from "hooks/useMetaData";
import React from "react";
import { Helmet } from "react-helmet";

const MetaData: React.FC = () => {
  const metaData = useMetaData();
  return (
    <Helmet>
      {metaData?.titleMeta && <title>{metaData.titleMeta}</title>}
      {metaData?.descriptionMeta && <meta name="description" content={metaData.descriptionMeta} />}
      {metaData?.tagsMeta && <meta property="keywords" content={metaData.tagsMeta} />}
    </Helmet>
  );
};

export default MetaData;
